<template>
  <Portal>
    <div
      v-if="isOpen"
      :class="[
        'base-modal',
        {
          'color-black': colorBlack,
          'color-blur': colorBlur,
          'hidden': hidden,
          'size-mobile-full-screen': sizeMobileFullScreen,
          'full-screen': fullScreen,
          'size-small': sizeSmall,
          'size-small-to-big': sizeSmallToBig,
          'no-backdrop': c_noBackdrop,
          'no-body-padding': noBodyPadding,
        },
      ]"
      :style="{ 'z-index': zIndex }"
      @keyup.esc="onEsc"
      @mousedown.self="onClickOutside"
      @wheel.prevent
    >
      <div class="base-modal__inner">
        <span v-if="!fullScreen" class="base-modal__shine" />
        <template v-if="!sizeSmall">
          <UiBtn
            v-if="!c_noBack"
            class="base-modal__back"
            icon="index-first-screen/chevron-left"
            color="gray"
            @click="onBack"
          />
          <UiBtn
            v-if="!c_noClose"
            class="base-modal__close"
            data-id="big-modal-close"
            icon="common/close"
            color="transparent"
            :data-gtm-id="dataGtmIdClose"
            :data-testid="dataTestid"
            @click="onClose"
          />
        </template>
        <template v-else>
          <UiBtn
            v-if="!c_noClose"
            class="base-modal__close"
            :data-id="closeDataId"
            icon="common/close"
            color="transparent"
            :data-gtm-id="dataGtmIdClose"
            :data-testid="dataTestid"
            @click="onClose"
          />
        </template>
        <div
          ref="modalBodyRef"
          class="base-modal__body"
          :style="bodyStyle"
          tabindex="0"
          @click.stop
          @wheel.stop
          @scroll.stop
        >
          <slot :is-open="isOpen" />
          <slot name="gradient" />
        </div>
      </div>
    </div>
  </Portal>
</template>
<script>
import { Portal } from '@linusborg/vue-simple-portal'
import { allModalsProps, baseAndLocalModalProps } from '@/components/Base/Modal/sharedProps'

const VAR_BODY_MAX_WIDTH = '--modal-body-width'

export default {
  name: 'BaseModal',
  components: { Portal },
  props: {
    isOpen: { type: Boolean, required: true },
    closeDataId: { type: String, default: '' },
    ...baseAndLocalModalProps,
    ...allModalsProps,
  },
  data() {
    return {
      zIndex: 9999,
    }
  },
  computed: {
    bodyStyle() {
      const res = {}
      if (this.maxWidth) res[VAR_BODY_MAX_WIDTH] = this.maxWidth
      return res
    },
    c_noClose() {
      return this.hidden || this.noClose
    },
    c_noBack() {
      return this.hidden || this.noBack
    },
    c_noBackdrop() {
      return this.hidden || this.noBackdrop
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      async handler() {
        this.$nextTick(() => {
          this.addFocus()
        })
        if (this.isOpen) {
          this.zIndex = await this.$store.dispatch('base/getZIndexCounter')
        }
      },
    },
  },
  mounted() {
    this.addFocus()
  },
  methods: {
    addFocus() {
      if (!this.isOpen) return
      setTimeout(() => {
        if (this.$refs.modalBodyRef) {
          this.$refs.modalBodyRef.focus()
        }
      }, 100)
    },
    onClickOutside() {
      if (this.hidden || this.noClickOutside) return
      this.onCancel()
    },
    onClose() {
      if (this.c_noClose) return
      this.onCancel()
    },
    onEsc() {
      if (this.noEsc) return
      this.onCancel()
    },
    onBack() {
      if (this.closeOnBack) this.onCancel()
      this.$emit('back')
    },
    onCancel() {
      if (this.clearQuery && Object.keys(this.$route.query).length > 0) {
        this.$router.replace({ path: this.$route.path })
      }
      this.$emit('cancel')
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
